var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { useRevalidator } from 'react-router';
import { useSetAtom } from 'jotai';
import { Translate } from "../../../../../../../I18N";
import { ConfirmationModal } from "../../../../../../Components/UI";
import * as extractorsAPI from "../../../../../../api/paragraphExtractor/extractors";
import { notificationAtom } from "../../../../../../atoms";


const DeleteDialog = ({
  setIsProcessing,
  onSuccess,
  selected,
  isOpen = false,
  setIsOpen = () => {}






}) => {
  const revalidator = useRevalidator();
  const setNotifications = useSetAtom(notificationAtom);

  const handleDelete = async () => {
    setIsProcessing(true);

    try {
      await extractorsAPI.remove(selected);
      await revalidator.revalidate();
      setIsOpen(false);
      setNotifications({
        type: 'success',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Extractor/s deleted")
      });
      onSuccess();
    } catch (error) {
      setNotifications({
        type: 'error',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "An error occurred")
      });
    }

    setIsOpen(false);
    setIsProcessing(false);
  };

  return (/*#__PURE__*/
    React.createElement(React.Fragment, null,
    isOpen && /*#__PURE__*/
    _jsx(ConfirmationModal, {
      header: /*#__PURE__*/_jsx(Translate, {}, void 0, "Are you sure?"),
      warningText: /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Only the extractor will be deleted, all created entities will remain on the library."

      ),

      acceptButton: /*#__PURE__*/_jsx(Translate, {}, void 0, "Delete"),
      cancelButton: /*#__PURE__*/_jsx(Translate, {}, void 0, "No, cancel"),
      onAcceptClick: handleDelete,
      onCancelClick: () => setIsOpen(false) }
    )

    ));

};

export { DeleteDialog };